/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccessTokenDtoFromJSON, AccessTokenDtoToJSON, } from './AccessTokenDto';
/**
 * Check if a given object implements the MyAlbumInfoIdRequestDto interface.
 */
export function instanceOfMyAlbumInfoIdRequestDto(value) {
    if ((!('albumId' in value) && !('album_id' in value)) || (value['albumId'] === undefined && value['album_id'] === undefined))
        return false;
    return true;
}
export function MyAlbumInfoIdRequestDtoFromJSON(json) {
    return MyAlbumInfoIdRequestDtoFromJSONTyped(json, false);
}
export function MyAlbumInfoIdRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'albumId': json['album_id'],
        'token': json['token'] == null ? undefined : AccessTokenDtoFromJSON(json['token']),
    };
}
export function MyAlbumInfoIdRequestDtoToJSON(json) {
    return MyAlbumInfoIdRequestDtoToJSONTyped(json, false);
}
export function MyAlbumInfoIdRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'album_id': value['albumId'],
        'token': AccessTokenDtoToJSON(value['token']),
    };
}
